// removed by extract-text-webpack-plugin
module.exports = {"doneButton":"_3w7-6","createAlbumButton":"_1eHr-","page":"_1x-TX","intro":"_15AfZ","numberInput":"_1g9eO","dateInput":"_3LAvH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/playlist/AlbumEditModal.css
// module id = 828
// module chunks = 0